import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../components/LanguageToggle';

export default function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 flex flex-col">
      {/* Language toggle in corner */}
      <div className="absolute top-4 ltr:right-4 rtl:left-4 z-10">
        <LanguageToggle />
      </div>

      {/* Centered card */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Logo / branding */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto rounded-2xl bg-primary-600 flex items-center justify-center shadow-lg mb-4">
              <span className="text-white text-3xl font-bold">م</span>
            </div>
            <h1 className="text-2xl font-bold text-primary-800">
              {t('appName')}
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              {t('appNameFull')}
            </p>
          </div>

          {/* Auth card */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
            <Outlet />
          </div>

          {/* Footer */}
          <p className="text-center text-xs text-gray-400 mt-6">
            &copy; {new Date().getFullYear()} Qalamy - قلمي
          </p>
        </div>
      </div>
    </div>
  );
}
